<!-- footer.vue -->
<template>
	<div
		class="ui-detail-footer"
		v-if="detailInfo"
		v-bind:class="{
			'hidden-cart-footer': ispromotion,
			'show-cart-footer': !ispromotion
		}"
	>
		<div class="footer-flex">
			<div class="left">
				<div class="item" v-on:click="goCart()">
					<span class="iconfont">&#xe6ae;</span>
					<span class="icon" v-if="cartNumber > 0">{{ getCarCount }}</span>
					<span class="text">购物车</span>
				</div>

			</div>
			<div class="right">
				<div
						class="button "
						:class="canBuy?'active-cart':'disabled-cart'"
						v-on:click="addShopping(true)"
						v-if="((!detailInfo.pintuan_type && detailInfo.cart) || (detailInfo.pintuan_type && (detailInfo.pintuangroup_list.length || detailInfo.pintuanorder_state)))"
				>
					{{addCartText}}
				</div>
				<div
						class="button "
						:class="canBuy?'active-buy':'disabled-buy'"
						v-on:click="checkout()"
				>
					{{buyNowText}}
				</div>
			</div>
		</div>

		<p class="good-stock-none" v-if="detailInfo.goods_state != 1">
			所选产品已下架，非常抱歉！
		</p>
		<p class="good-stock-none" v-else-if="detailInfo.goods_storage <= 0">
			所选产品暂时无货，非常抱歉！
		</p>

		<shopping v-if="isShowcartInfo" :isShowcartInfo="isShowcartInfo"></shopping>

		<!-- 加入购物车显示动画 -->
		<div class="ui-cart-animation" v-if="isAnimation">
			<mt-spinner type="snake" color="#e93b3d"></mt-spinner>
		</div>
	</div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { Toast } from 'mint-ui'
import shopping from './child/Shopping'
import { cartQuantity } from '../../../api/homecart'
export default {
  data () {
    return {

		addCartText: '加入购物车',
		buyNowText: '立即购买',
      cartNumber: 0,
      isAnimation: false // 加入购物车成功之后是否显示动画
    }
  },

  components: {
    shopping
  },

  props: {
    ishidefooter: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapState({
		config: state => state.config.config,
		user: state => state.member.info,
      // 是否显示购物车浮层
      isShowcartInfo: state => state.goodsdetail.isShowcartInfo,
      detailInfo: state => state.goodsdetail.detailInfo,
		specList: state => state.goodsdetail.specList,
      isOnline: state => state.member.isOnline,
      ispromotion: state => state.goodsdetail.ispromotion,
      // cartNumber: state => state.tabBar.cartNumber,
      chooseinfo: state => state.goodsdetail.chooseinfo,
      number: state => state.goodsdetail.number
    }),
	  canBuy () {
		  if (this.detailInfo.goods_storage > 0 && this.detailInfo.goods_state == 1) {
			  return true
		  } else {
			  return false
		  }
	  },
    getCarCount () {
      if (this.cartNumber > 0 && this.cartNumber < 100) {
        return this.cartNumber
      } else if (this.cartNumber >= 100) {
        return '99+'
      }
    }
  },

  created () {

	  if (this.detailInfo.pintuan_type) {
		  if (this.detailInfo.pintuanorder_state) {
			  if (this.detailInfo.pintuanorder_state == 1) {
				  this.addCartText = '参团中'
			  } else {
				  this.addCartText = '已成团'
			  }
			  this.buyNowText = '原价购买'
		  } else {
			  this.addCartText = '参加拼团'
			  this.buyNowText = '立刻开团'
		  }
	  } else if (this.detailInfo.is_presell == 1) {
		  this.buyNowText = '预售购买（' + this.$moment.unix(this.detailInfo.presell_deliverdate).format('YYYY年MM月DD日') + '发货）'
	  } else if (this.detailInfo.is_goodsfcode == 1) {
		  this.buyNowText = 'F码购买'
	  }
    this.$on('start-addcart-animation', () => {
      this.isAnimation = true
    })
    this.$on('end-addcart-animation', () => {
      this.isAnimation = false
      this.saveCartState(false)
    })
	  this.getCartCount()
	  this.$on('update-cart-num', () => {
		  this.getCartCount()
	  })
  },

  methods: {
    ...mapMutations({
      saveCartState: 'saveCartState',
      changeType: 'changeType',
      saveSelectedCartGoods: 'saveSelectedCartGoods'
    }),
	  getCartCount () {
		  if(this.isOnline){
			  cartQuantity().then(res => {
				  if (res) {
					  this.cartNumber = res.result.cart_count
				  }
			  })
		  }
	  },
    // 加入购物车
    addShopping (value) {
      this.saveCartState(value)
      this.changeType('确定')
    },

    // 立即购买
    checkout () {
		if (!this.canBuy) {
			return
		}
		if(this.specList && Object.keys(this.specList).length>1){
			this.addShopping(true)
			return
		}
      if (this.detailInfo.is_virtual == '1') {
      let params = { goods_id: this.detailInfo.goods_id, quantity: 1 }
      if (this.detailInfo.pintuan_type && !this.detailInfo.pintuanorder_state) {
          params['pintuan_id'] = this.detailInfo.pintuan_id
          params['pintuangroup_id'] = 0
        }
		  this.$router.push({ name: 'MemberVrBuyStep1', query: params })
      } else {
      	let params={ buy_now: 1, cart_id: this.detailInfo.goods_id + '|1' }
      	if(this.detailInfo.pintuan_type && !this.detailInfo.pintuanorder_state){
			params['pintuan_id']=this.detailInfo.pintuan_id
			params['pintuangroup_id']=0
		}
		  this.$router.push({ name: 'MemberBuyStep1', query: params })

      }
    },

    // 购物车
    goCart () {
      if (this.isOnline) {
        this.$router.push({ name: 'HomeCart', params: { type: 0 } })
      } else {
        this.$router.push({ name: 'HomeMemberLogin' })
      }
    },

    /*
		 * fromatArray: 格式化数组
		 */
    fromatArray (delimiter, arrays) {
      let data = ''
      if (delimiter) {
        data = arrays.join(delimiter)
      }
      return delimiter ? data : arrays
    },

    /*
		 * isHasStock: 是否还有库存
		 */
    isHasStock (id) {
      let data = this.detailInfo.stock
      if (data.length > 0) {
        for (let i = 0, len = data.length; i <= len - 1; i++) {
          if (data[i].goods_attr == id) {
            return '' + data[i].stock_number + ''
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ui-detail-footer {
	background: rgba(255, 255, 255, 1);
	border-top: 0.5px solid #e8eaed;
	width: auto;
	position: absolute;
	bottom: 0;
	left: 0;
	right: 0;
	z-index: 0;
	&.hidden-cart-footer {
		display: none;
	}

	&.show-cart-footer {
		display: block;
	}

	.footer-flex {
		display: flex;
		justify-content: space-between;
		align-content: center;
		align-items: center;
		height: 2.2rem;
	}
	p.good-stock-none {
		width: 100%;
		height: 1.6rem;
		background: #c3c3c3;
		opacity: 0.5;
		font-size: 0.7rem;
		color: #333;
		position: absolute;
		text-align: center;
		line-height: 1.6rem;
		padding: 0;
		margin: 0;
		bottom: 2.2rem;
	}
	div.left {
		display: flex;
		justify-content: center;
		align-items: center;
		width: 7.5rem;
		.item{flex:1;text-align: center;line-height: 1;position:relative;
			.iconfont {
				flex-shrink: 0;
				font-size:1.3rem;

			}
			.text{font-size:.5rem;color:gray;display: block}
		}
		span.icon {
			position: absolute;
			right: 0;
			top: 0;
			font-size: 0.5rem;
			line-height: 0.7rem;
			width: 0.9rem;
			height: 0.7rem;
			background: #ef3338;
			border-radius: 1rem;
			text-align: center;
			color: #ffffff;
		}
	}
	div.right {
		flex: 1;
		display: flex;
		flex-direction: row;
		.button {
			flex: 1;
			height: 2.2rem;
			font-size: 0.7rem;
			color: #ffffff;
			text-align: center;
			line-height: 2.2rem;
			cursor: pointer;
		}
		.disabled-cart {
			background: #c3c3c3;
		}
		.active-cart {
			background: $primaryColor;
		}
		.disabled-buy {
			background: #999999;
		}
		.active-buy {
			background: #000;
		}
	}
}
.ui-cart-animation {
	position: fixed;
	top: 50%;
	left: 50%;
}
</style>
